import { FC, useCallback } from "react";

import __ from "web/Layout/Translations";

import classes from "./sort.scss";

interface ISortProps {
  action: () => void;
  name: string;
  ariaLabel: string;
}

const Sort: FC<ISortProps> = ({ action, name, ariaLabel }) => {
  const clickHandler = useCallback(() => {
    if (typeof action === "function") {
      action();
    }
  }, [action]);

  return (
    <button
      type="button"
      data-t1={`multiselect_sort_button_${name}`}
      className={classes.root}
      onClick={clickHandler}
      aria-label={__(ariaLabel)}
    >
      {name}
    </button>
  );
};

export default Sort;
